// outline blue button

import React from "react";

export default function SolidBlueBtn({ disabled, children, onClick, className, style }) {
  return (
    <button disabled={disabled} className={`${disabled ? 'solid-disabled-btn' : 'solid-blue-btn' } ` + (className || "")} style={style || {}} onClick={onClick}>
      {children}
    </button>
  );
}
